import { render, staticRenderFns } from "./SecretStorages.vue?vue&type=template&id=8585cbee&scoped=true"
import script from "./SecretStorages.vue?vue&type=script&lang=js"
export * from "./SecretStorages.vue?vue&type=script&lang=js"
import style0 from "./SecretStorages.vue?vue&type=style&index=0&id=8585cbee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8585cbee",
  null
  
)

export default component.exports